(() => {
  function init(root = document) {
    root.querySelectorAll('[data-jw-storefront]').forEach((store) => {
      if (store.dataset.jwReady) return;
      store.dataset.jwReady = 'true';
      const main = store.querySelector('#jw-main-image');
      store.querySelectorAll('[data-jw-thumb]').forEach((button) => {
        button.addEventListener('click', () => {
          if (!main) return;
          main.removeAttribute('srcset');
          main.src = button.dataset.src;
          main.alt = button.dataset.alt;
          store.querySelectorAll('[data-jw-thumb]').forEach((thumb) => {
            thumb.classList.toggle('is-active', thumb === button);
            thumb.setAttribute('aria-pressed', String(thumb === button));
          });
        });
      });
      const lightbox = store.querySelector('[data-jw-lightbox]');
      store.querySelector('[data-jw-zoom]')?.addEventListener('click', () => {
        if (!main || !lightbox) return;
        const image = lightbox.querySelector('img');
        image.src = main.currentSrc || main.src;
        image.alt = main.alt;
        lightbox.showModal();
      });
      lightbox?.querySelector('[data-jw-close]')?.addEventListener('click', () => lightbox.close());
      lightbox?.addEventListener('click', (event) => { if (event.target === lightbox) lightbox.close(); });
      store.querySelectorAll('[data-jw-step]').forEach((button) => button.addEventListener('click', () => {
        const input = button.parentElement.querySelector('input');
        input.value = String(Math.max(1, Math.min(99, (Number(input.value) || 1) + Number(button.dataset.jwStep))));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }));
      const form = store.querySelector('[data-jw-product-form]');
      if (form) {
        const price = store.querySelector('[data-jw-selected-price]');
        const stickyPrice = store.querySelector('[data-jw-sticky-price]');
        const buy = form.querySelector('[data-jw-buy-now]');
        const selectPack = () => {
          const selected = form.querySelector('[data-jw-variant]:checked');
          if (!selected) return;
          if (price) price.textContent = selected.dataset.price;
          if (stickyPrice) stickyPrice.textContent = selected.dataset.price;
          buy.disabled = selected.disabled || selected.dataset.available !== 'true';
        };
        form.querySelectorAll('[data-jw-variant]').forEach((radio) => radio.addEventListener('change', selectPack));
        selectPack();
        form.addEventListener('submit', (event) => {
          event.preventDefault();
          if (!form.reportValidity()) return;
          const selected = form.querySelector('[data-jw-variant]:checked');
          if (!selected || selected.disabled || buy.disabled) return;
          const quantity = Number(form.querySelector('[name="quantity"]').value);
          if (!Number.isInteger(quantity) || quantity < 1 || quantity > 99) return;
          const checkout = new URL(buy.dataset.cartUrl.replace(/\/$/, '') + '/' + encodeURIComponent(selected.value) + ':' + quantity, window.location.origin);
          window.location.assign(checkout.href);
        });
      }
      const sticky = store.querySelector('[data-jw-sticky]');
      const purchase = store.querySelector('.jw-purchase');
      if (sticky && purchase && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.bottom < 0));
        observer.observe(purchase);
        document.addEventListener('shopify:section:unload', () => observer.disconnect(), { once: true });
      }
    });
    const topic = root.querySelector('[data-jw-topic]');
    if (topic && new URLSearchParams(location.search).get('subject')?.includes('review')) topic.value = 'review';
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
